import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import { AiSparklesGradient, AiMessageSmall } from '@vy/ui-design-system';
import {
  emptyStateRoot,
  emptyStateIconCircle,
  emptyStateTextBlock,
  emptyStateHeading,
  emptyStateSubtext,
  emptyStateSuggestionList,
  emptyStateSuggestionButton,
  emptyStateSuggestionText,
} from '../styles';

const MAX_SUGGESTIONS = 5;

const DEFAULT_SUGGESTIONS = [
  'Give me a full recognized revenue analysis',
  "What's my total recognized revenue this quarter?",
  'Top 10 customers by recognized revenue',
  'Show recognized revenue trend by month',
  'Which customers have concentration risk?',
  'Break down recognized revenue by product',
];

type EmptyStateProps = {
  onSuggestionClick: (text: string) => void;
  suggestions?: string[];
};

export const EmptyState: React.FC<EmptyStateProps> = ({ onSuggestionClick, suggestions }) => {
  const items = (suggestions ?? DEFAULT_SUGGESTIONS).slice(0, MAX_SUGGESTIONS);
  return (
    <Box sx={emptyStateRoot}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px', width: '100%' }}>
        <Box sx={emptyStateIconCircle}>
          <AiSparklesGradient width={33} height={33} />
        </Box>
        <Box sx={emptyStateTextBlock}>
          <Typography sx={emptyStateHeading}>Hi, I'm your AI Insight Agent</Typography>
          <Typography sx={emptyStateSubtext}>What would like to analyze?</Typography>
        </Box>
      </Box>
      <Box sx={emptyStateSuggestionList}>
        {items.map((suggestion) => (
          <ButtonBase
            key={suggestion}
            onClick={() => onSuggestionClick(suggestion)}
            sx={emptyStateSuggestionButton}
          >
            <Box sx={{ width: 16, height: 16, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <AiMessageSmall />
            </Box>
            <Typography sx={emptyStateSuggestionText}>{suggestion}</Typography>
          </ButtonBase>
        ))}
      </Box>
    </Box>
  );
};
